import React, {Component} from 'react';
import {connect} from 'react-redux';
import {logout} from 'actions/AuthActions';

class WorkerNavBar extends Component {
  logoutBtnOnClick = () => {
    let { dispatch } = this.props

    dispatch(logout());
  }

  render() {
    return (
      <header className="header">
        <h3 className="text-muted pull-left">Worker System</h3>
        {/*
        <ul className="nav nav-pills menu pull-right">
          <li>
            <a href="#" onClick={this.logoutBtnOnClick}>
              <span className="glyphicon glyphicon-log-out" aria-hidden="true"></span>
              登出
            </a>
          </li>
        </ul>
        */}
      </header>
    )
  }
}

export default connect()(WorkerNavBar);


// WEBPACK FOOTER //
// ./src/components/WorkerNavBar.js